<template>
  <el-popover placement="bottom" :width="300" trigger="hover" :disabled="disabled == null? false:disabled">
    <template #reference>
      <el-input
          :style="style"
          v-model="tempModel"
          autocomplete="off"
          placeholder="请选择部门"
          :disabled="disabled == null? false:disabled"
      ></el-input>
    </template>
    <el-tree
        style="color: #000;height:200px;overflow:auto"
        ref="tree"
        class="tree"
        highlight-current:true
        :data="depart"
        show-checkbox
        node-key="id"
        :props="defaultProps"
        :check-strictly=true
    >
      <template #default="{ node }">
                <span class="custom-tree-node">
                  <span style="color: #000">{{ node.label }}</span>
                </span>
      </template>
    </el-tree>
    <el-button type="primary" @click="getCheckedKeyssEdit" size="small"
    >OK
    </el-button
    >
  </el-popover>
</template>
<script>

import {getDepartmentTree} from "@/request/BasicDataApi"

export default {
  name: "multiple depart select",
  data() {
    return {
      depart: [],
      defaultProps: {//tree格式
        children: "children",
        label: "label",
        id: "id",
      },
      tempModel: null,
    }
  },
  props: [
    'model',
    'keys',
    'style',
    'disabled',
  ],
  created() {
    getDepartmentTree().then((res) => {
      this.depart = res.data
    });
  },
  mounted() {
    if (this.keys != null)
      this.$refs.tree.setCheckedKeys(JSON.parse(this.keys), false)
  },
  methods: {
    //修改多选部门节点
    getCheckedKeyssEdit() {
      let departNodes = this.$refs.tree.getCheckedNodes();
      let departIdList = this.$refs.tree.getCheckedKeys();
      let departLabelList = ''
      if (departNodes.length > 0) {
        for (let i = 0; i < departNodes.length; i++) {
          departLabelList += departNodes[i].label + ",";
        }
      }
      console.log(departIdList, departNodes)
      this.$emit('id', JSON.stringify(departIdList))
      this.$emit('name', departLabelList)
    },
  },
  watch: {
    // 'keys'(){
    //   this.$refs.tree.setCheckedKeys(this.keys)
    // }
    'model'(e){
      this.tempModel = e
    },
  }
}
</script>

<style scoped>

</style>
